import React, { FC } from 'react';
import { FormSpy, useForm } from 'react-final-form';
import { getIn } from 'final-form';
import useFirstRender from 'hooks/useFirstRender';

type WhenTwoFieldChangesProps = {
  name: string;
  nameFrom: string;
  nameTo: string;
  calculateNewValue: (valueFrom: string, valueTo: string) => string;
};

const WhenTwoFieldChanges: FC<WhenTwoFieldChangesProps> = ({
  name,
  nameFrom,
  nameTo,
  calculateNewValue,
}) => {
  const { change } = useForm();

  const isFirstRender = useFirstRender();

  return (
    <FormSpy
      subscription={{ values: true }}
      onChange={({ values }) => {
        if (isFirstRender) return;

        const valueFrom = getIn(values, nameFrom);
        const valueTo = getIn(values, nameTo);
        const oldValue = getIn(values, name);
        const newValue = calculateNewValue(valueFrom, valueTo) || '';

        const isChangedValue = oldValue !== newValue;

        if (valueFrom && valueTo && isChangedValue) {
          change(name, newValue);
        } else if ((!valueFrom || !valueTo) && oldValue) {
          change(name, '');
        }
      }}
    />
  );
};

export default WhenTwoFieldChanges;
